export default __webpack_public_path__ + "static/media/airplane.30b29741.svg";